import Vue from 'vue';
import VueParallaxJs from 'vue-parallax-js';

Vue.use(VueParallaxJs, {
  minWidth: 760
  //className: '',
});


//////////////////
// WEBPACK FOOTER
// ./plugins/parallax.js
// module id = ./plugins/parallax.js
// module chunks = 5